import ApiInstance from './instance'
import {
  ETrainingMilestoneStatus,
  ITrainingMilestone,
  EAlertStatus,
  IUserAlertSettings,
  ITrainingMilestoneTemplate
} from '@zunta/configurations'

export default class TrainingApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }
  importMilestones (file: File) {
    const formData = new FormData()
    formData.append('milestones', file)
    return this.instance.doPost(`/training/importMilestones`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  saveTemplateOrder (templates: ITrainingMilestoneTemplate[]) {
    return this.instance.doPut('/training/saveTemplates', { templates })
  }
  editOnboardingTemplate (id: number | string, data: Partial<ITrainingMilestoneTemplate>) {
    return this.instance.doPatch(`/training/editMilestoneTemplate/${id}`, data)
  }
  deleteOnboardingTemplate (id: number | string) {
    return this.instance.doDelete(`/training/deleteMilestoneTemplate/${id}`)
  }
  createMilestoneTemplate (data: { parent?: number, name: string }) {
    return this.instance.doPatch('/training/createMilestoneTemplate', data)
  }
  getUserOverdueHistory (userId: number | string, weeks: number, skip: number) {
    return this.instance.doGet(`/training/userOverdueHistory/${userId}`, {
      weeks,
      skip
    })
  }
  getUserAlerts (userId: number | string) {
    return this.instance.doGet(`/training/alerts/${userId}`)  
  }
  changeAlertStatus (alertId: number | string, data: { status: EAlertStatus, comments: string, dueDate?: Date | string | number }) {
    return this.instance.doPut(`/training/alerts/changeStatus/${alertId}`, { data })
  }

  getUserAlertSettings (userId: number | string): Promise<IUserAlertSettings[]> {
    return this.instance.doGet(`/training/alerts/settings/user/${userId}`)
  }

  updateUserAlertSettings (settings: IUserAlertSettings[]): Promise<'OK'> {
    return this.instance.doPut(`/training/alerts/settings/update`, { settings })
  }
  getTodos (query: any) {
    return this.instance.doGet(`/training/todo/data`, query, 'adminTodoList')
  }
  getTodosPagination (current: number | string = 0, query: any = {}) {
    return this.instance.doGet(`/training/todo/pagination`, { current, ...query })
  }
  getDashboardData () {
    return this.instance.doGet(`/training/dashboard/user-data`)
  }
  getTodosStatistics (query: any) {
    return this.instance.doGet(`/training/todo/statistics`, query)
  }
  importTrainingMilestoneTemplates (file: File) {
    const formData = new FormData()
    formData.append('report', file)
    return this.instance.doPost(`/training/importTrainingMilestoneTemplates`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
 
  saveTrainingMilestones (userId: number | string, milestones: ITrainingMilestone[]) {
    return this.instance.doPut(`/training/saveTrainingMilestones/${userId}`, { milestones })
  }
  getUserTrainingMilestones (userId: number | string): Promise<ITrainingMilestone[]> {
    return this.instance.doGet(`/training/trainingMilestones/${userId}/all`)
  }
  changeTrainingMilestoneStatus (milestone: number | string, status: ETrainingMilestoneStatus) {
    return this.instance.doPatch(`/training/changeTrainingMilestoneStatus/${milestone}`, { status })
  }
}
